export function matchesExactKey(event, { key, ctrl = false, shift = false, alt = false, meta = false }) {
    if (event.ctrlKey !== ctrl || event.shiftKey !== shift || event.altKey !== alt || event.metaKey !== meta) {
        return false;
    }
    if (event.key.toLowerCase() !== key.toLowerCase()) {
        return false;
    }
    const hasUnexpectedModifiers = ((event.ctrlKey && event.metaKey) ||
        (event.altKey && !alt) ||
        (event.shiftKey && !shift) ||
        (event.ctrlKey && !ctrl) ||
        (event.metaKey && !meta));
    return !hasUnexpectedModifiers;
}
export function createPlatformShortcut(key, options = {}) {
    const isMac = typeof navigator !== 'undefined' && navigator.platform.toUpperCase().indexOf('MAC') >= 0;
    return {
        key,
        meta: isMac,
        ctrl: !isMac,
        ...options
    };
}
